export const kpiDefinitionsStoreKey = 'kpiDefinitions';
